var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import GamesRedeem from "./redeem";
import { GamesBanner } from "./style";
import { px2rem } from "../../utils/size";
import styled from "styled-components";
const Wrap = styled.div `
	width: 100%;
	height: ${px2rem(80)};
`;
class Games extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = () => __awaiter(this, void 0, void 0, function* () {
            const { callbackSpmByurl, callback, data, moduleId } = this.props;
            callbackSpmByurl(data.link);
            if (yield callback(moduleId)) {
                this.changeShow(true);
            }
        });
        this.changeShow = (show) => {
            this.setState({
                show
            });
        };
        this.handleEnter = () => {
            const { callbackToLink, data } = this.props;
            callbackToLink(data.activeId);
        };
        this.state = {
            show: false
        };
    }
    render() {
        const { data, positionId } = this.props;
        const { show } = this.state;
        return (React.createElement(Wrap, { id: positionId },
            React.createElement(GamesBanner, { src: data.img, onClick: this.handleClick }),
            React.createElement(GamesRedeem, { show: show, onClose: () => this.changeShow(false), onEnter: this.handleEnter })));
    }
}
export default Games;
